import { classNames } from '@dimjs/utils';
import { CSSProperties, ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { bodyAppendDivElement } from '../utils';
import './style.less';

export type TDynamicNodeProps = {
  className?: string;
  getContainer?: HTMLElement | (() => HTMLElement) | string;
  content?: ReactElement;
  fixed?: boolean;
  style?: CSSProperties;
};

/**
 * 动态添加 element 元素
 * ```
 * 1. 默认添加到 body 下
 * 2. 可通过 getContainer 参数设置添加位置
 * ```
 */
export const dynamicNode = {
  append: (props: TDynamicNodeProps = {}) => {
    const container = (() => {
      let tempElement;
      if (typeof props.getContainer === 'string') {
        tempElement = document.querySelector(props.getContainer);
      } else if (typeof props.getContainer === 'function') {
        tempElement = props.getContainer();
      }
      return tempElement as Element | undefined;
    })();

    const className = classNames('v-dynamic-node', { 'v-dynamic-node-fixed': props.fixed }, props.className);
    let nodeElementId = `id_${Date.now()}`;
    if (container) {
      ReactDOM.render(
        <div className={className} id={nodeElementId}>
          {props.content}
        </div>,
        container,
      );
    } else {
      const { divElement, elementId } = bodyAppendDivElement();
      nodeElementId = elementId;
      ReactDOM.render(<div className={className}>{props.content}</div>, divElement);
    }
    window['_dynamic_node_element_id'] = nodeElementId;
    console.log('nodeElementId', nodeElementId);
    return {
      elementId: nodeElementId,
    };
  },
  remove: (elementId?: string) => {
    const dynamicElementId = elementId || window['_dynamic_node_element_id'];
    if (dynamicElementId) {
      try {
        document.querySelector(`#${dynamicElementId}`)?.remove();
      } catch (error) {
        //
      }
    }
  },
};
